import React, { useState } from "react";
import "./CircleImageUpload.css";

const CircleImageUpload = () => {
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
    }
  };

  const handleDeleteImage = () => {
    setPreview(null);
  };

  return (
    <div className="upload-container">
      {/* <label className="upload-label">Upload File</label> */}
      <div className="circle-container">
        <div className="image-wrapper">
          <label htmlFor="file-upload" className="circle">
            {preview ? (
              <img src={preview} alt="Preview" className="circle-image" />
            ) : (
              <span className="placeholder-text">NO IMAGE</span>
            )}
            <input
              id="file-upload"
              type="file"
              className="file-input"
              accept="image/*"
              onChange={handleFileChange}
            />
          </label>
          {preview && (
            <button className="btn btn-primary btn-sm delete-button" onClick={handleDeleteImage}>
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CircleImageUpload;
